import { render, staticRenderFns } from "./edit_style.vue?vue&type=template&id=6bc7ed2f&"
import script from "./edit_style.vue?vue&type=script&lang=js&"
export * from "./edit_style.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports